<div class="row">
    <div class="col-sm-12 search-col">
        <div class="input-group search-field">
            <input [(ngModel)]="searchString" type="text" placeholder="Quick Search"
                   class="filter-input input form-control search-field__input"
                   (input)="searchOnInput()" maxlength="300" (keyup)="navigateByArrows($event)">
            <div class="input-group-btn search-field__button">
                <button *ngIf="searchString" (click)="clearSearch()" class="btn btn btn-default clear-search">
                    <i class="fa fa-times"></i>
                </button>
                <div *ngIf="!searchString" class="btn btn btn-default bd-left-none">
                    <i class="fa fa-search"></i>
                </div>
            </div>
        </div>
        <ul class="nav filter-list" *ngIf="searchString !== '' && listOfUsers.length >= 1 && !noMatches">
            <li *ngFor="let item of listOfUsers">
                <a class="filter-list-item" (click)="viewResident(item)">
                    <div class="list-item-wrapper-head">
                        <div class="list-item-header">
                            <span class="list-item-unit" ngxTextHighlight [content]="item.suite.suiteNumber"
                                  [searchTerm]="searchString" [caseSensitive]="false">
                                Unit {{item.suite.suiteNumber}}
                            </span>
                            <span class="grey-circle">•</span>
                            <span class="list-item-name" ngxTextHighlight [content]="item.user.fullName"
                                  [searchTerm]="searchString" [caseSensitive]="false">
                                {{item.user.fullName}}
                            </span>
                        </div>
                        <div class="list-item-role">
                            <span *ngIf="item.role=='owner_off'" class="label owner-off-label">Owner Off-Site</span>
                            <span *ngIf="item.role=='owner_on'" class="label owner-on-label">Owner On-Site</span>
                            <span *ngIf="item.role=='rent'" class="label rent-label">Tenant</span>
                            <span *ngIf="item.role=='occupant'" class="label occupant-label">Occupant</span>
                            <span *ngIf="item.role=='resident'" class="label resident-label">Resident</span>
                            <span *ngIf="item.role=='offsite_resident'" class="label offsite-resident-label">
                                Offsite Resident
                            </span>
                            <span *ngIf="item.role=='guest'" class="label guest-label">Guest</span>
                            <span *ngIf="item.role=='resident_owner'" class="label resident-owner-label">
                                Resident Owner
                            </span>
                            <span *ngIf="item.role=='resident_only_not_on_deed'"
                                  class="label resident-only-not-on-deed-label">Resident Only Not On Deed</span>
                            <span *ngIf="item.role=='owner_family'" class="label owner-family-label">Owner Family</span>
                            <span *ngIf="item.role=='unknown'" class="label label-default">Not Set</span>
                        </div>
                    </div>
                    <div class="list-item-wrapper-body">
                        <div>
                            <span class="list-item-email">{{item.user.email}}</span>
                        </div>
                        <div>
                            <span class="list-item-phone"
                                  *ngIf="item.user.primaryPhone">{{item.user.primaryPhone}}</span>
                            <span class="list-item-phone"
                                  *ngIf="!item.user.primaryPhone && item.user.phones.length">{{item.user.phones[0].phone}}</span>
                            <span class="list-item-phone"
                                  *ngIf="!item.user.primaryPhone && !item.user.phones.length">Not set</span>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
        <ul class="nav filter-list" *ngIf="noMatches && searchString !== '' && listOfUsers.length < 1">
            <li>
                <a class="filter-list-item text-c">No Matches</a>
            </li>
        </ul>
    </div>

</div>



// WEBPACK FOOTER //
// /app/src/app/components/quick-search/quick-search.component.html